export const SET_LOCATIONS = 'setLocations';
export const SET_GEOCODE = 'setGeoCode';
export const SET_UPS_LOCATIONS = 'setUpsLocations';
export const SET_MACYS_LOCATIONS = 'setStoresLocations';
export const SET_STORES = 'setStores';
export const SET_UNAVAILABLE_STORES = 'setUnavailableStores';
export const SET_STORES_ERROR = 'setStoresError';
export const SET_API_LOADING = 'setApiLoading';
export const RESET_STORE = 'resetStore';
export const SET_SELECTED_STORE = 'setSelectedStore';
export const SET_SEARCH_BY_ZIPCODE = 'setsearchByZipCode';
export const SET_DIVISION_NUMBER = 'setDivisionNumber';
export const SET_RESULTS_DISPLAYED = 'setResultsDisplayed';
export const SET_LOCATION_RADIUS = 'setLocationRadius';
export const SET_PREFILLED_ZIPCODE = 'setPrefilledZipCode';
export const SET_IS_BRIDAL = 'setIsBridal';
export const SET_PAGE = 'setPage';
export const SET_UPC_NUMBER = 'setUpcNumber';
export const SET_BAG_ITEMS = 'setBagItems';
export const SET_USE_FCC_API = 'setUseFCCApi';
export const SET_SHOW_ACCORDION = 'setShowAccordion';
export const SET_CURBSIDE_HOURS = 'setCurbsideHours';
export const SET_AVAILABILITY = 'setAvailability';
export const SET_FULFILLMENT_ZIPCODE_EMPTY_STORE = 'setFulfillmentZipcodeEmotyStore';
export const SET_FCC_MACYS_API_KEY = 'setFccMacysApiKey';
export const SET_SEARCH_LOCATION_BY_ADDRESS = 'setSearchLocationByAddress';
export const SET_BT_ITEMS = 'setBTItems';
export const SET_PRODUCT_ID = 'setProductId';
export const SET_AREA_RUG_ITEMS = 'setAreaRugItems';
